import React from "react";
import { useTip } from "../ui/Tooltip/Tooltip";
import { CHART_COLORS } from "../../styles/theme";

/** Pyramide des âges. rows : [{ tranche, femmes, hommes }] */
const Pyramid = ({ rows = [], width = 440, rowHeight = 32 }) => {
    const tip = useTip();
    const max = Math.max(...rows.map((r) => Math.max(r.femmes, r.hommes))) || 1;
    const height = rows.length * rowHeight + 10;
    const cx = width / 2;
    const half = (width - 150) / 2;
    const barH = Math.min(20, rowHeight - 11);

    return (
        <svg viewBox={`0 0 ${width} ${height}`} width="100%">
            {rows.map((r, i) => {
                const y = 8 + i * rowHeight;
                const wf = (r.femmes / max) * half;
                const wh = (r.hommes / max) * half;
                return (
                    <g key={r.tranche}>
                        <text
                            x={cx}
                            y={y + 15}
                            textAnchor="middle"
                            fontSize="16"
                            fill={CHART_COLORS.muted}
                        >
                            {r.tranche}
                        </text>
                        <rect
                            x={cx - 72 - wf}
                            y={y + 3}
                            width={wf}
                            height={barH}
                            rx="2.5"
                            fill={CHART_COLORS.violet}
                            {...tip(
                                `${r.tranche} · Femmes : ${r.femmes} collab.`
                            )}
                        />
                        <rect
                            x={cx + 72}
                            y={y + 3}
                            width={wh}
                            height={barH}
                            rx="2.5"
                            fill={CHART_COLORS.blue}
                            {...tip(
                                `${r.tranche} · Hommes : ${r.hommes} collab.`
                            )}
                        />
                    </g>
                );
            })}
        </svg>
    );
};

export default Pyramid;
